import axios from "axios";
import { dataDecrypt } from "../utils/helpers";

const accountBaseURL = process.env.REACT_APP_ACCOUNT_BASE_URL;
const accountApiKey = process.env.REACT_APP_ACCOUNTS_API_KEY;
const transactionBaseURL = process.env.REACT_APP_TRANSACTION_BASE_URL;
const transactionApiKey = process.env.REACT_APP_TRANSACTION_API_KEY;

export const accountsInstance = axios.create({
  baseURL: accountBaseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",
    apiKey: accountApiKey,
  },
});

export const transactionInstance = axios.create({
  baseURL: transactionBaseURL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",
    apiKey: transactionApiKey,
  },
});

const onRequest = (request) => {
  const admin_token = JSON.parse(
    dataDecrypt(localStorage.getItem("admin_token")),
  );
  const client_token = JSON.parse(
    dataDecrypt(localStorage.getItem("client_token")),
  );

  request.headers.Authorization =
    `Bearer ${
      location.pathname.includes("client/") ? client_token : admin_token
    }` || "";

  return request;
};

const onRequestError = (error) => {
  return Promise.reject(error);
};

const onResponse = (response) => {
  return response;
};

const onResponseError = async (error) => {
  const statusCode = error.response?.status;
  if (statusCode === 401) {
    sessionStorage.clear();
    localStorage.clear();
    setTimeout(() => {
      window.location.href = `/auth`;
    }, 500);
  }

  return Promise.reject(error);
};

accountsInstance.interceptors.request.use(onRequest, onRequestError);
accountsInstance.interceptors.response.use(onResponse, onResponseError);
transactionInstance.interceptors.request.use(onRequest, onRequestError);
transactionInstance.interceptors.response.use(onResponse, onResponseError);
